export default __webpack_public_path__ + "static/media/view_in_ar.d2d14aba.svg";